import React, { Component } from 'react'

export class Pagination extends Component {

  constructor(props) {
    super(props);
    this.state = {
      selected_page: this.props.selectPage,
      paginationNumbers : [],
      postPerPage : 10,
      limit: 0
    }
  }

  render() {
    this.state.selected_page = this.props.selectPage;
    this.state.postPerPage = this.props.limit;
    const paginationNumbers = [];
    let limit_page = Math.ceil(this.props.totalPageLength / this.state.postPerPage);
    let end_page = limit_page;

    let start = 1;
    let end = 10;

    if (this.state.selected_page > 5) {
      start += this.state.selected_page - 5;
      end += this.state.selected_page - 5;

    }
    if (this.state.selected_page >= limit_page - 5) {
      start = Math.ceil(this.props.totalPageLength / this.state.postPerPage) - 10;
      end = Math.ceil(this.props.totalPageLength / this.state.postPerPage);
    }
    if (limit_page > 10) {
      // show only 10 pagination
      limit_page = 10;
    }
    
    for (let i = start; i <= end; i++) {
      if (i>0) {
      paginationNumbers.push(i);
      }
    }
    return (
        <nav>
        <ul className="pagination justify-content-center">
          <li className={`page-item ${this.state.selected_page === 1? "disabled" : ""}`}>
            <div className="page-link" to="#" onClick={() => {
              this.setState({selected_page: 1});
              this.props.onPaginationPress(1);
            }}>
              
              <span class="ti-arrow-left"></span>
            </div>
          </li>
          {
            paginationNumbers.map(page => {
              return <li className={`page-item ${this.state.selected_page === page? "active" : ""}`}><div className="page-link" href="/" onClick={() => {
                this.props.onPaginationPress(page);
                this.setState({selected_page: page});
              }}>{page}</div></li>
            })
          }
          <li className={`page-item ${this.state.selected_page === end_page? "disabled" : ""}`}>
            <div className="page-link" href="/" onClick={() => {
              this.props.onPaginationPress(Math.ceil(this.props.totalPageLength / this.state.postPerPage));
              this.setState({selected_page: Math.ceil(this.props.totalPageLength / this.state.postPerPage) });
            }}>
              <span className="ti-arrow-right"></span>
            </div>
          </li>
        </ul>
      </nav>
    )
  }
}

export default Pagination